document.addEventListener('DOMContentLoaded', function() {
  if (!document.querySelector('.permission-container')) return;

  let state = {}
  state = { observerType: document.querySelector('.permission-container').dataset.userClass };

  // Permission configuration
  const PERMISSIONS = state.observerType === 'InspectionObserver' ? {
    microphone: {
      name: 'microphone',
      displayName: 'Microphone',
      queryName: 'microphone',
      requestMethod: requestMediaPermission.bind(null, { audio: true }),
      elementId: 'mic-permission'
    }} : {
    location: {
      name: 'location',
      displayName: 'Location',
      queryName: 'geolocation',
      requestMethod: requestGeolocationPermission,
      elementId: 'location-permission'
    },
    camera: {
      name: 'camera',
      displayName: 'Camera',
      queryName: 'camera',
      requestMethod: requestMediaPermission.bind(null, { video: true }),
      elementId: 'camera-permission'
    },
    microphone: {
      name: 'microphone',
      displayName: 'Microphone',
      queryName: 'microphone',
      requestMethod: requestMediaPermission.bind(null, { audio: true }),
      elementId: 'mic-permission'
    }
  };

  // Permission state tracking
  const permissionState = Object.keys(PERMISSIONS).reduce((acc, key) => {
    acc[key] = false;
    return acc;
  }, {});

  // Initialize
  setupPermissionButtons();
  checkAllPermissions();

  // Main functions
  function setupPermissionButtons() {
    document.querySelectorAll('.request-btn').forEach(button => {
      const permissionType = button.dataset.permission;
      button.addEventListener('click', () => {
        const permissionConfig = PERMISSIONS[permissionType];
        const statusDiv = button.parentElement.querySelector('.status');
        permissionConfig.requestMethod(statusDiv, permissionConfig);
      });
    });
  }

  async function checkAllPermissions() {
    for (const [key, config] of Object.entries(PERMISSIONS)) {
      await checkPermission(key, config);
    }
    updateJoinCallVisibility();
  }

  async function checkPermission(permissionKey, config) {
    const { elementId, displayName, queryName } = config;
    const button = document.querySelector(`#${elementId} .request-btn`);
    const statusDiv = document.querySelector(`#${elementId} .status`);

    try {
      // Try Permissions API first
      if (navigator.permissions?.query) {
        const permissionStatus = await navigator.permissions.query({ name: queryName });

        updatePermissionState(permissionKey, permissionStatus.state, button, statusDiv, displayName);

        permissionStatus.onchange = () => {
          updatePermissionState(permissionKey, permissionStatus.state, button, statusDiv, displayName);
          updateJoinCallVisibility();
        };
      }
      // Fallback to specific checks
      else if (permissionKey === 'location') {
        checkGeolocationFallback(permissionKey, button, statusDiv, displayName);
      } else {
        await checkMediaFallback(permissionKey, button, statusDiv, displayName);
      }
    } catch (error) {
      window.rollbar.error(`Error checking ${displayName} permission:`, error);
      updatePermissionUI('prompt', button, statusDiv, displayName);
      permissionState[permissionKey] = false;
      $(`#${elementId}`).removeClass('d-none');
    }
  }

  function updatePermissionState(permissionKey, state, button, statusDiv, displayName) {
    updatePermissionUI(state, button, statusDiv, displayName);
    permissionState[permissionKey] = state === 'granted';
    console.log(`Permission ${permissionKey} state:`, permissionState[permissionKey]);
    $(`#${PERMISSIONS[permissionKey].elementId}`).toggleClass('d-none', state === 'granted');
    updateJoinCallVisibility();
  }

  // Permission request methods
  function requestGeolocationPermission(statusDiv, config) {
    const button = document.querySelector(`#${config.elementId} .request-btn`);

    if (!navigator.geolocation) {
      statusDiv.textContent = "Geolocation is not supported by your browser";
      return;
    }

    statusDiv.textContent = `Requesting ${config.displayName}...`;

    navigator.geolocation.getCurrentPosition(
      () => updatePermissionState(config.name, 'granted', button, statusDiv, config.displayName),
      () => updatePermissionState(config.name, 'denied', button, statusDiv, config.displayName)
    );
  }

  async function requestMediaPermission(constraints, statusDiv, config) {
    const button = document.querySelector(`#${config.elementId} .request-btn`);

    if (!navigator.mediaDevices?.getUserMedia) {
      statusDiv.textContent = `${config.displayName} API is not supported by your browser`;
      return;
    }

    statusDiv.textContent = `Requesting ${config.displayName}...`;

    try {
      await navigator.mediaDevices.getUserMedia(constraints);
      updatePermissionState(config.name, 'granted', button, statusDiv, config.displayName);
    } catch (err) {
      updatePermissionState(config.name, 'denied', button, statusDiv, config.displayName);
    }
  }

  // Fallback methods for browsers without Permissions API support
  function checkGeolocationFallback(permissionKey, button, statusDiv, displayName) {
    // Geolocation has no good fallback other than trying to request it
    updatePermissionUI('prompt', button, statusDiv, displayName);
    permissionState[permissionKey] = false;
    $(`#${PERMISSIONS[permissionKey].elementId}`).removeClass('d-none');
  }

  async function checkMediaFallback(permissionKey, button, statusDiv, displayName) {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const deviceKind = permissionKey === 'camera' ? 'videoinput' : 'audioinput';
      const hasAccess = devices.some(device => device.kind === deviceKind && device.label);

      updatePermissionState(
        permissionKey,
        hasAccess ? 'granted' : 'prompt',
        button,
        statusDiv,
        displayName
      );
    } catch (error) {
      window.rollbar.error(`Error checking ${displayName} devices:`, error);
      updatePermissionState(permissionKey, 'prompt', button, statusDiv, displayName);
    }
  }

  // UI update functions
  function updatePermissionUI(state, button, statusDiv, permissionName) {
    switch(state) {
      case 'granted':
        button.style.display = 'none';
        statusDiv.textContent = `${permissionName} access already granted`;
        statusDiv.style.color = 'green';
        break;
      case 'denied':
        button.style.display = 'none';
        statusDiv.textContent = `${permissionName} access was denied. Please update in browser settings.`;
        statusDiv.style.color = 'red';
        break;
      default: // prompt or unknown
        button.style.display = 'block';
        statusDiv.textContent = state === 'prompt'
          ? `${permissionName} access required`
          : `Could not determine ${permissionName} permission status`;
        statusDiv.style.color = 'inherit';
    }
  }

  function updateJoinCallVisibility() {
    if(state.observerType === 'InspectionObserver') {
      $('.permission-container').removeClass('d-none');

      $('#joinCall').toggleClass('d-none', !permissionState.microphone);
    } else {
      if (permissionState.camera && permissionState.microphone) {
        $('#joinCall').removeClass('d-none');
      } else {
        $('#joinCall').addClass('d-none');
        $('.permission-container').removeClass('d-none');
      }
    }
  }
});
